import { render, staticRenderFns } from "./OrderImageInfo.vue?vue&type=template&id=f75b4196"
import script from "./OrderImageInfo.vue?vue&type=script&lang=js"
export * from "./OrderImageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports